/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskForm990JSON
 */
export interface ExecRiskForm990JSON {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990JSON
     */
    irs_object_id: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskForm990JSON
     */
    ein: number;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990JSON
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990JSON
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990JSON
     */
    filing_date?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskForm990JSON
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExecRiskForm990JSON
     */
    return_header?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExecRiskForm990JSON
     */
    irs_990?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExecRiskForm990JSON
     */
    irs_990_ez?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExecRiskForm990JSON
     */
    schedule_a?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ExecRiskForm990JSON
     */
    schedule_r?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ExecRiskForm990JSON interface.
 */
export function instanceOfExecRiskForm990JSON(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "irs_object_id" in value;
    isInstance = isInstance && "ein" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "address" in value;

    return isInstance;
}

export function ExecRiskForm990JSONFromJSON(json: any): ExecRiskForm990JSON {
    return ExecRiskForm990JSONFromJSONTyped(json, false);
}

export function ExecRiskForm990JSONFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskForm990JSON {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'irs_object_id': json['irs_object_id'],
        'ein': json['ein'],
        'name': json['name'],
        'address': json['address'],
        'filing_date': !exists(json, 'filing_date') ? undefined : json['filing_date'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'return_header': !exists(json, 'return_header') ? undefined : json['return_header'],
        'irs_990': !exists(json, 'irs_990') ? undefined : json['irs_990'],
        'irs_990_ez': !exists(json, 'irs_990_ez') ? undefined : json['irs_990_ez'],
        'schedule_a': !exists(json, 'schedule_a') ? undefined : json['schedule_a'],
        'schedule_r': !exists(json, 'schedule_r') ? undefined : json['schedule_r'],
    };
}

export function ExecRiskForm990JSONToJSON(value?: ExecRiskForm990JSON | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'irs_object_id': value.irs_object_id,
        'ein': value.ein,
        'name': value.name,
        'address': value.address,
        'filing_date': value.filing_date,
        'version': value.version,
        'return_header': value.return_header,
        'irs_990': value.irs_990,
        'irs_990_ez': value.irs_990_ez,
        'schedule_a': value.schedule_a,
        'schedule_r': value.schedule_r,
    };
}

